module.exports = __webpack_public_path__ + "img/IMAGE.10ef4934.svg";